<template>
  <el-dialog title="速成教育视频服务条款" :visible.sync="termsOfServiceVisible" width="750px" top="1vh" center :before-close="onClose">
    <span>
      <table>
        <tr>
          <td style="width: 100px;" valign="top">
            <span>【信息获取】</span>
          </td>
          <td>
            <p>
              用户通过本站观看的所有视频皆出自于速成教育， 版权归速成教育所属。当发生任何关于视频回看的技术问题时，学员可向前台客服寻求帮助。
            </p>
          </td>
        </tr>
        <tr>
          <td valign="top">
            <span>【线上线下课程视屏通用使用须知】</span>
          </td>
          <td>
            <p>学员通过本站服务来观看视频时，应该注意以下几点：</p>
            <p>1. 速成学员在满足规定的条件下，才可享受免费观看的机会。</p>
            <p>2. 如果学员需要缴费看视频时，可以使用速成学员账户中的积分、余额进行付款，若金额不足，请联系速成教育前台或对应校区客服进行线上充值。</p>
            <p>3. 学员在观看每节课视频时，其实际可观看总时长为该视频课时长度的倍数({{studentVideoDurationText}})。</p>
          </td>
        </tr>
        <!-- <tr>
          <td valign="top">
            <span>【关于退款】</span>
          </td>
          <td>
            <p>
              2.1 若用户无法前来速成校区观看视频并于预约时间24小时前取消，预约时缴纳的视频观看费用将退还至用户的账户；
              24小时内，预约时缴纳的视频观看费用将退还50%至用户的账户；
              3小时内，任何预约无法取消，无法退款。
            </p>
            <p>
              2.2 若用户在没有告知速成行政人员的前提下，未能前来速成校区观看视频，费用将
              不给于退还。
            </p>
          </td>
        </tr> -->
      </table>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<style lang="scss" scoped>
table {
  margin: 0 40px;
  p {
    font-size: 12px;
    margin-bottom: 5px;
    color: black;
  }
  span{
     color: #1756a6;            
  }
}
.el-dialog__title {
  font-size: 19px;
}

</style>

<script>
export default {
  data() {
    return {};
  },
  props: {
    termsOfServiceVisible: Boolean,
    studentVideoDurationText: String
  },
  updated() {},
  created() {},
  methods: {
    onClose() {
      this.$emit("closeDialog");
    },
    onOk() {
      this.$emit("onOk");
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/termsOfServiceInfo.vue